"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[946],{

/***/ 6965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6493);
/* harmony import */ var _styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5444);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _MixPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5067);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5828);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    &::placeholder {\n        font-size : 13px;\n        font-weight : 300\n    }\n    &:disabled {\n        opacity : 0.6;\n    }\n    &::before {\n        content: attr(placeholder);\n        position: absolute;\n        color: #999999;\n    }\n\n    &:focus::before,\n    &:valid::before {\n        content: "";\n    }\n\n    color-scheme: dark;\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].textarea.withConfig */ .ZP.textarea.withConfig({
    componentId: "sc-5794fd29-0"
})(_templateObject());
function TextArea(props, ref) {
    const type = props.type || "text";
    const placeholder = props.placeholder || "";
    const prefix = props.prefix || "";
    const suffix = props.suffix || "";
    const outerProperties = props.outerProperties || "";
    const autoComplete = props.search || false;
    const background = props.background || "white";
    const color = props.color || "black";
    const labelColor = props.labelColor || "white";
    const labelProperties = props.labelProperties || "";
    const touched = props.touched || false;
    const error = props.error || null;
    const searchResults = props.searchResults || [];
    const value = props.value || "";
    const disabled = props.disabled || false;
    // FUNCTION
    const handleOnFocus = ()=>{
        if (props.onFocus) props.onFocus();
        const mixPanelData = {
            inputName: props.name ? props.name : "",
            inputValue: value
        };
        _MixPanel__WEBPACK_IMPORTED_MODULE_3__/* .MixpanelTracking.getInstance */ .n.getInstance().trackInput(mixPanelData);
    };
    const handleOnChange = (event)=>{
        if (props.onChange) props.onChange(event);
        const mixPanelData = {
            inputName: props.name ? props.name : "",
            inputValue: type !== "password" ? event.target.value : "**********"
        };
        if (props.name !== "ProductSearch") _MixPanel__WEBPACK_IMPORTED_MODULE_3__/* .MixpanelTracking.getInstance */ .n.getInstance().trackInput(mixPanelData, true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "flex-col",
        children: [
            props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                className: "inline-block mb-1 ".concat(labelProperties),
                style: {
                    color: labelColor
                },
                children: [
                    " ",
                    props.label,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                onClick: ()=>ref && ref.current.focus(),
                className: "flex bg-white justify-center items-center cursor-text ".concat(outerProperties),
                style: {
                    background: background
                },
                children: [
                    prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_6___default().prefix),
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, {
                        ref: ref,
                        className: "".concat((_styles_General_Input_module_css__WEBPACK_IMPORTED_MODULE_6___default().input), " focus:outline-0 ").concat(props.properties),
                        placeholder: placeholder,
                        style: {
                            background: background,
                            color: color
                        },
                        onChange: handleOnChange,
                        onInput: props.onInput,
                        name: props.name,
                        onBlur: props.onBlur,
                        value: value,
                        disabled: disabled,
                        onFocus: handleOnFocus,
                        rows: 3
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "suffix",
                        children: suffix
                    })
                ]
            }),
            error && touched && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                className: "text-error",
                children: [
                    " ",
                    error,
                    " "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(TextArea));


/***/ }),

/***/ 7625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _General_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8472);
/* harmony import */ var _General_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(348);
/* harmony import */ var _General_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3607);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _General_Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7418);
/* harmony import */ var _validations_Enquiry__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6578);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2175);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2298);











function EnquiryForm(props) {
    let initialValues = {
        created_by_name: "",
        created_by_phone: "",
        created_by_email: "",
        created_by_company_name: "",
        dial_code: {
            label: "+91",
            value: "+91"
        }
    };
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const { enquiryState  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)((state)=>state.core);
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm , setFieldValue  } = (0,formik__WEBPACK_IMPORTED_MODULE_7__/* .useFormik */ .TA)({
        initialValues: initialValues,
        validationSchema: _validations_Enquiry__WEBPACK_IMPORTED_MODULE_6__/* .enquiryFormWithoutLoginSchema */ .G3,
        onSubmit: (values, action)=>{
            const payload = {
                ...values,
                ...props.data
            };
            payload["created_by_phone"] = "".concat(payload.dial_code.value, "-").concat(payload["created_by_phone"]);
            dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_8__/* .submitEnquiry */ .yW)(payload));
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(()=>{
        if (enquiryState.showSuccessModal) {
            props.onClose();
            resetForm();
        }
    }, [
        enquiryState.showSuccessModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            show: props.show,
            styles: "w-4/5 lg:w-1/3",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pt-5 pb-14 max-h-[90vh] overflow-y-auto px-5 lg:px-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "close flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "text-theme-black text-xl",
                                children: [
                                    " ",
                                    props.data.product && props.data.product_string,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                onClick: props.onClose,
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "w-6 h-6 cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M6 18L18 6M6 6l12 12"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "py-5 lg:grid grid-cols-2",
                        children: [
                            props.data.expected_certificates && props.data.expected_certificates.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-sm text-theme-black lg:text-[13px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "opacity-70",
                                        children: "Certificates : "
                                    }),
                                    props.data.expected_certificates.map((certificate, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                certificate.name,
                                                index !== props.data.expected_certificates.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: " / "
                                                })
                                            ]
                                        }, index))
                                ]
                            }),
                            props.data.country_string && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-sm text-theme-black lg:text-[13px]",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "opacity-70",
                                        children: "Delivery Country"
                                    }),
                                    " : ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            " ",
                                            props.data.country_string,
                                            " "
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-sm text-error lg:text-[13px]",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "opacity-70 text-theme-black",
                                        children: "QTY : "
                                    }),
                                    " ",
                                    props.data.quantity,
                                    " KG "
                                ]
                            }),
                            props.data.expected_date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-sm text-theme-black lg:text-[13px]",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "opacity-70",
                                        children: " Delivery Date "
                                    }),
                                    " : ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            " ",
                                            props.data.expected_date && (0,date_fns_format__WEBPACK_IMPORTED_MODULE_10__["default"])(props.data.expected_date, "dd/MM/yyyy"),
                                            " "
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "pb-5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        label: "Name",
                                        labelColor: "#444444",
                                        labelProperties: "opacity-50",
                                        properties: "border border-slate-300 rounded h-11 placeholder:text-sm",
                                        placeholder: "Enter Name",
                                        name: "created_by_name",
                                        value: values.created_by_name,
                                        onBlur: handleBlur,
                                        onChange: handleChange,
                                        error: errors.created_by_name,
                                        touched: touched.created_by_name
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pt-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        label: "Email",
                                        labelColor: "#444444",
                                        labelProperties: "opacity-50",
                                        properties: "border border-slate-300 rounded h-11 placeholder:text-sm",
                                        placeholder: "Enter Email",
                                        name: "created_by_email",
                                        value: values.created_by_email,
                                        onBlur: handleBlur,
                                        onChange: handleChange,
                                        error: errors.created_by_email,
                                        touched: touched.created_by_email
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "pt-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            className: "inline-block mb-1 text-theme-black opacity-50",
                                            children: " Phone "
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-start items-start",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        width: "25%"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        search: true,
                                                        suffix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            strokeWidth: 1.5,
                                                            stroke: "currentColor",
                                                            className: "w-6 h-6",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                                            })
                                                        }),
                                                        defaultValue: {
                                                            label: "+91",
                                                            value: "+91"
                                                        },
                                                        value: values.dial_code,
                                                        onChange: (selected)=>setFieldValue("dial_code", selected),
                                                        placeholder: "+XX",
                                                        items: props.countryList,
                                                        additionalStyles: {
                                                            padding: "2.4px 3px"
                                                        },
                                                        selectedColor: "gray",
                                                        placeholderStyles: {
                                                            fontSize: 13,
                                                            fontWeight: 300
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        width: "75%"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        type: "text",
                                                        labelColor: "#444444",
                                                        labelProperties: "opacity-50",
                                                        properties: "border border-slate-300 rounded h-11 placeholder:text-sm",
                                                        outerProperties: "pl-3",
                                                        placeholder: "Enter Phone",
                                                        name: "created_by_phone",
                                                        value: values.created_by_phone,
                                                        onBlur: handleBlur,
                                                        onChange: handleChange,
                                                        error: errors.created_by_phone,
                                                        touched: touched.created_by_phone,
                                                        maxLength: 10
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pt-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        label: "Company Name",
                                        labelColor: "#444444",
                                        labelProperties: "opacity-50",
                                        onChange: handleChange,
                                        properties: "border border-slate-300 rounded h-11 placeholder:text-sm",
                                        placeholder: "Enter Company Name",
                                        name: "created_by_company_name",
                                        value: values.created_by_company_name,
                                        onBlur: handleBlur,
                                        error: errors.created_by_company_name,
                                        touched: touched.created_by_company_name
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    type: "submit",
                                    styles: "bg-theme-orange text-white w-full mt-8 h-12",
                                    children: "Submit"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EnquiryForm);


/***/ }),

/***/ 6113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _General_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8472);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1266);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);




function EnquirySuccess(param) {
    let { show , user  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const close = ()=>{
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__/* .closeEnquirySuccessModal */ .Mv)());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        show: show,
        styles: "w-[80%] lg:w-1/4",
        transition: "animateup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "content pt-4 pb-10 px-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        onClick: close,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 1.5,
                        stroke: "currentColor",
                        className: "w-6 h-6 cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M6 18L18 6M6 6l12 12"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/Layout/EnquirySuccess.png",
                        width: 200,
                        height: 200,
                        alt: "Success",
                        className: "pt-3 pb-6"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "content text-center px-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-theme-black font-semibold",
                            children: [
                                "Hey! ",
                                user
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "pt-2 text-theme-black font-light",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-theme-orange font-semibold",
                                    children: "Thank you "
                                }),
                                "for showing interest. We will get in touch with you with next steps within 24 Hours"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
EnquirySuccess.defaultProps = {
    user: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (EnquirySuccess);


/***/ }),

/***/ 6578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G3": function() { return /* binding */ enquiryFormWithoutLoginSchema; },
/* harmony export */   "kA": function() { return /* binding */ ShortEnquiryFormSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4231);

const enquiryFormSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    product_string: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Product is required!"),
    country_string: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Country is required!"),
    quantity: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("Quantity is required!").nullable().typeError("quantity should be a valid number!"),
    price: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("Price is required!").nullable().typeError("Price should be a valid number!"),
    required_manufacturer: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Manufacturer is required!"),
    expected_certificates: yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().min(1, "Please select at least 1 certificate!"),
    pharmacopoeia_grades: yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().min(1, "Please select at least 1 grade!"),
    expected_date: yup__WEBPACK_IMPORTED_MODULE_0__/* .date */ .hT().required("Date is required!").nullable().typeError("Must be a valid date!"),
    shipping_terms: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Shipping Terms is required!")
});
const enquiryFormWithoutLoginSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    created_by_name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("This field is required!"),
    created_by_email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email().required("This field is required!"),
    created_by_phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("This field is required!").nullable().typeError("Please enter a valid phone number!"),
    created_by_company_name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("This field is required!")
});
const ShortEnquiryFormSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    product_string: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Product is required!"),
    quantity: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("Quantity is required!").nullable().typeError("quantity should be a valid number!"),
    message: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Message is required!")
});
/* harmony default export */ __webpack_exports__["ZP"] = (enquiryFormSchema);


/***/ })

}]);